const getters = {
  getFirstTransitionStatus: (state) => state.isFirstTransition
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/onboarding/getters.js